import * as React from 'react';
import styles from './Content.module.css';

function Face() {

  const [backgroundColour, setBackgroundColour] = React.useState("#1700c7");

  function handleColorChange(input) {
    const lightness = getLightnessFromHex(input);
    const oppositeColor = lightness > 60 ? 'black' : 'white';

    document.documentElement.style.setProperty('--main-bg-color', input);
    document.documentElement.style.setProperty('--opposite-color', oppositeColor);

    setBackgroundColour(input); // THIS triggers re-render
  }


  return (
    <main className={styles.printPage} id="root" >

      <div className={styles.printContent} >


        <header />

        <div className={styles.container} >

          <h1 class="inverted" >ZEMOJ.TEL</h1 >
          <hr />
          <h2>Hi, I'm <a target="_blank" href="mailto:szymonzemojtel@gmail.com">Szymon Zemojtel</a></h2>
          <sub>Vancouver | 20 | Computer Science & Game Development</sub>

          <p>I love software development and jazz</p>



          <p></p>






          <h2 id="cats">My cats</h2>
          <hr />

          <div class="cats">
            <div class="cats-left">
              {/* <img src="mumba and ginger.jpg"></img> */}
              <img src="ginger.jpg"></img>
              <div></div>
              <img src="mumba and ginger 2.jpg"></img>
            </div>
            <div class="cats-right">
              These are my cats!
              <p>Ginger (white and orange one) is 3 years old and super hyper. She has constant zoomies and loves to go under things, like blankets, tubes, and bags. She loves laying flat on her chest.</p>
              <p>Mumba (black one) is also 3 years old but is the opposite of Ginger. He is super soft, loves to cuddle, and use scratchers. His favourite thing in the world is food. When its time to feed them, Mumba gets so excited he starts running around in circles in the kitchen.</p>
            </div>


          </div>




          <h2 id="projects">My Projects</h2>
          <hr />
          <div class="media">

            <div id="picknplace" class="media-item">
              <img src="https://media2.giphy.com/media/v1.Y2lkPTc5MGI3NjExZXhjNzZtYTk1eG1ocTg0b2RzZTd4Zm54ZmpweHJtNnAwOGppZmtzNiZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/2xUFqtvWJbuUw23FPY/giphy.gif"></img>
              <span class="inverted">Pick n' Place</span>
              <div>
                <p>A framework for dragging and dropping objects in Unity. Inspired by Balatro, the framework allows for individual slots, and both vertical and horizontal hands.</p>
                <p>For this framework I tried to focus on covering all the edge cases a user might encounter. My goal was to create a robust solution to easily make virtual board games.</p>

              </div>
            </div>


            <div id="card-game" class="media-item">
              <img src="https://media0.giphy.com/media/v1.Y2lkPTc5MGI3NjExeTMydDhqN3I1Y3VyYjVkdG05dzA3YXh6dm84MTlnN2FkeXU3ZzM2biZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/XXeyzacwD7fIEEVOj6/giphy.gif"></img>
              <span class="inverted">Game Where You Play Cards And Get Rules And Try Not To Lose Your Cards</span>
              <div>
                <p>This game prototype was made in 4 days for the GMTK Game Jam 2026 alongside my classmate from BCIT. Made in Godot.</p>
                <p>The core concept of this game is scoring by the value of the players cards, but after each round the player can add another rule, like clubs multiply by 2 or 8's get +5.</p>
                <p>We focused on strong user feedback and simple gameplay. We also implemented a in depth settings page, focusing on reusability in any future Godot projects.</p>

              </div>
            </div>

            <div class="media-item" id="cart-crawl">
              <img src="https://media3.giphy.com/media/v1.Y2lkPTc5MGI3NjExYnY1OGx1eDg0YzhxanZrYnpxZnhuNHN0ajc3aW42c2xvNGhnM3d1biZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/8Od8nHNhaRLXOAAyNs/giphy.gif"></img>
              <span class="inverted">Cart Crawl (Game Jam Winner)</span>
              <div>
                <p>This game was the winner of <a target="_blank" href="https://itch.io/jam/boba-design-jam-2-prizes-">Boba Jam 2</a> in 2023. It was made solo, in just 48 hours in Unity. During the game jam, I focused on the core gameplay (an MVP). I sourced CC0 assets online to speed up the development and prototyping process.</p>
                <p>After the jam finished, I continued to work on the game to polish it up and add more features. The main feature I wanted to add is a more engaging way to place rails. In the jam submission version, you place rails by spamming left click. In this improved post-jam version, the player can more easily drag to place rails and must draw patterns corresponding to each rail for them to be placed (best visualized in the gif).</p>
                <p>The jam version is up on Itch.io to try out! <a target="_blank" href="https://itch.io/jam/boba-design-jam-2-prizes-">Jam submission version</a></p>
              </div>
            </div>


            <div class="media-item" id="vr-wand">
              <img src="https://media1.giphy.com/media/v1.Y2lkPTc5MGI3NjExazloOHB6MXB1ZmhqeGFkdXAyNzByNXowM29kbjF6b2ZzdXhuanV4eSZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/EZzsjZJu2XiOuA3tWw/giphy.gif"></img>
              <span class="inverted">VR Wand</span>
              <div>
                <p>VR and AR has always been super interesting to me. I love experimenting with different ways of interacting with a virtual environment. Building off my pattern recognition system from Cart Crawl, I wanted to create an interesting approach to magic wands.</p>
                <p>The way I approached flattening the 3D wand path for a 2D pattern recognition algorithm was to flatten the points according to how the player saw them from their right eye.</p>

              </div>
            </div>


            <div class="media-item" id="tube-system">
              <img src="https://media2.giphy.com/media/v1.Y2lkPTc5MGI3NjExbzZvbzg0cGQ3cWkydTJvZWhwenpianJxdTBjMGpnenowcjYxcmxweiZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/ziKdeCE8qsDEMLOiyj/giphy.gif"></img>
              <span class="inverted">Tube System for Unity Asset Store</span>
              <div>
                <p>While working on a Unity project where a VR player fights against PC flatscreen players, I needed a tube system similar to the "clear pipes" from the Mario 3D series.</p>
                <p>After making the tube system for my project, I realized that there wasn't anything similar on the Unity asset store, so I dedicated a few days to polishing it up and making it compliant to the Unity Asset store.</p>
                <p>You can see it published <a target="_blank" href="https://assetstore.unity.com/packages/add-ons/tubular-tube-travel-system-285044">here</a> on the Unity Asset Store!</p>

              </div>
            </div>

            <div class="media-item" id="multiplayer-ik">
              <img src="https://media4.giphy.com/media/v1.Y2lkPTc5MGI3NjExbzZ4cHlxZWwyMHBkcWVwc3FjMmNhbGZkdG0ya244OTcyNDA1cTRocSZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/CZ067N1sYRSL8LQbF8/giphy.gif"></img>
              <span class="inverted">Multiplayer IK</span>
              <div>
                <p>Working on a crossplay VR vs flatscreen PC game in Unity, I wanted the PC players to be cartoonish ants that can pick up objects in their environment and realistically step onto objects. To tackle this, I used inverse kinematics (IK) for accurate foot placements, and made a front leg follow any grabbed object to make it look held by the player.</p>
                <p>As you can see in the background of the gif, I also experimented with having other AI creatures who also used IK. With some of those creatures, I also implemented a system sever their limbs, which would still let them walk, but slower. Using their stump as a foot.</p>
              </div>

            </div>


            <div class="media-item" id="inlet">
              <img src="https://media2.giphy.com/media/v1.Y2lkPTc5MGI3NjExN3VvZzJodW4zeHprdWk5eGJpZDQzbzlmemt6dmkzcmlzNXBzN3JnbyZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/4h1mQ9XsM78nTfMh3A/giphy.gif"></img>
              <span class="inverted">Inlet (5 Hour Game Personal Challenge)</span>
              <div>
                <p>Entire game created in Unity in 5 hours, immediately after a final exam. I wanted to celebrate the end of the term and have an outlet for all the creativity I had to suppress to focus on studying. Your goal is to fill each tile in the grid. The game is playable on Itch.io <a target="_blank"href="https://lastered.itch.io/inlet">here!</a> Each tile has a rule that must be followed to win:</p>
                <p>1. Water cannot be moved or replaced.</p>
                <p>2. Trees must touch water, and they can only be in a maximum group of 3.</p>
                <p>3. Mushrooms cannot touch one-another, but must touch a tree.</p>
                <p>4. Houses must be sandwiched between 2 tiles of the same type.</p>



              </div>

            </div>




          </div>



          <h2 id="music">Music</h2>
          <hr />
          <p>Click the album covers to go to the song!</p>
          <div class="music">
            <div class="music-item">
              <button onClick={() => {
                window.open(
                  "https://www.youtube.com/watch?v=vozK-7PS1mk",
                  "_blank",
                  "noopener,noreferrer"
                );
              }}>
                <img src="https://i.scdn.co/image/ab67616d0000b273b2932fc2d4c8f8621b13f375"></img>
              </button>
              <span class="inverted">SICK OF IT</span>
              <sub>femtanyl</sub>
            </div>



            <div class="music-item">
              <button onClick={() => {
                window.open(
                  "https://www.youtube.com/watch?v=b524HO-CS4U",
                  "_blank",
                  "noopener,noreferrer"
                );
              }}>
                <img src="https://i.scdn.co/image/ab67616d0000b273b5a7cac5f838dcd77512037d"></img>
              </button>
              <span class="inverted">メトロノーム</span>
              <sub>toe</sub>
            </div>

            <div class="music-item">
              <button onClick={() => {
                window.open(
                  "https://www.youtube.com/watch?v=eMjUKsi2evg",
                  "_blank",
                  "noopener,noreferrer"
                );
              }}>
                <img src="https://i.scdn.co/image/ab67616d0000b2739d9bf3fd5ba6d618d163b3f7"></img>
              </button>
              <span class="inverted">Plate</span>
              <sub>Genevieve Artadi</sub>
            </div>



            <div class="music-item">
              <button onClick={() => {
                window.open(
                  "https://www.youtube.com/watch?v=u-dicKzcCF0",
                  "_blank",
                  "noopener,noreferrer"
                );
              }}>
                <img src="https://i.scdn.co/image/ab67616d0000b273d1f513f8397d1952f28cf6a4"></img>
              </button>
              <span class="inverted">Weird Moments</span>
              <sub>Louis Cole</sub>
            </div>



            <div class="music-item">
              <button onClick={() => {
                window.open(
                  "https://www.youtube.com/watch?v=F5EFsUU7RRA",
                  "_blank",
                  "noopener,noreferrer"
                );
              }}>
                <img src="https://i.scdn.co/image/ab67616d0000b273b752bbaa0dd7578b736f7cc1"></img>
              </button>
              <span class="inverted">Early Summer</span>
              <sub>Ryo Fukui</sub>
            </div>

            <div class="music-item">
              <button onClick={() => {
                window.open(
                  "https://www.youtube.com/watch?v=hh9IPPSi3c4",
                  "_blank",
                  "noopener,noreferrer"
                );
              }}>
                <img src="https://i.scdn.co/image/ab67616d0000b27390ee068042e6372064a1f4c5"></img>
              </button>
              <span class="inverted smaller-text">What Is This Thing Called Love</span>
              <sub>Jesus Molina</sub>
            </div>



            <div class="music-item">
              <button onClick={() => {
                window.open(
                  "https://www.youtube.com/watch?v=TUHakoxcwTc",
                  "_blank",
                  "noopener,noreferrer"
                );
              }}>
                <img src="https://i.scdn.co/image/ab67616d0000b273dea0b4b4bba4b0ec8329fca9"></img>
              </button>
              <span class="inverted">Aliso 2023</span>
              <sub>David Binney</sub>
            </div>



            <div class="music-item">
              <button onClick={() => {
                window.open(
                  "https://www.youtube.com/watch?v=h3UgT-np7Rk",
                  "_blank",
                  "noopener,noreferrer"
                );
              }}>
                <img src="https://i.scdn.co/image/ab67616d0000b273426c1adfb6bd27d9f426a21d"></img>
              </button>
              <span class="inverted">parallel</span>
              <sub>how to count one to ten</sub>
            </div>

          </div>


          <footer>


              

              <p class="inverted">Created Feb 28 2026     |     Last updated Oct 3 2026</p>
              



          </footer>
        </div>
      </div>

    </main >
  );
}

export default Face



// this code was stolen from https://www.youtube.com/watch?v=7YaWnHVl7Hk
function getLightnessFromHex(hex) {
  hex = hex.replace(/^#/, '')

  const r = parseInt(hex.substr(0, 2), 16);
  const g = parseInt(hex.substr(2, 2), 16);
  const b = parseInt(hex.substr(4, 2), 16);

  // Luminance formula (perceived brightness)
  const brightness = (0.2126 * r + 0.7152 * g + 0.0722 * b) / 255;

  return +(brightness * 100).toFixed(2);

}


